import React from 'react';
import { FiLoader } from 'react-icons/fi';

/**
 * Full-page loading state. Fills the viewport with its own background —
 * only use it when it IS the whole page (route-level loading).
 *
 * Inside cards, modals or tab panels use `InlineSpinner` instead, otherwise
 * the `min-h-screen` here stretches the container to viewport height and the
 * spinner ends up floating in a huge empty white area.
 */
export const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center h-full min-h-screen bg-card-color-200 dark:bg-gray-900">
    <div className="flex flex-col items-center gap-4 text-gray-500 dark:text-gray-400">
      <FiLoader className="animate-spin text-4xl" />
      <p className="text-lg">Loading ...</p>
    </div>
  </div>
);

/** Compact spinner for sections, cards and modals. Takes no more height than its padding. */
export const InlineSpinner: React.FC<{ label?: string; className?: string }> = ({
  label,
  className,
}) => (
  <div
    className={`flex flex-col items-center justify-center gap-2 py-8 text-gray-500 dark:text-gray-400 ${className ?? ''}`}
  >
    <FiLoader className="animate-spin text-2xl text-blue-600" />
    {label && <p className="text-sm">{label}</p>}
  </div>
);